import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { Hashtag } from 'js/social/shared/types';

export async function getHashtagSearch(query: string): Promise<Hashtag[]> {
  const response = await fetchWithCsrf(
    routes.api_v0_community_hashtag_search_path({
      subdomain_param: 'api',
      q: query,
    }),
  );
  if (!response.ok) {
    throw new Error('Failed to get hashtag search');
  }

  return (await response.json()).results;
}
